import ExpandIcon from './ExpandIcon';

export default ExpandIcon;
